// extracted by mini-css-extract-plugin
module.exports = {"similarKeywordArea":"similarKeywordArea","similarKeywordArea__text-bold":"similarKeywordArea__text-bold"};